export default function () {
  window.onbeforeunload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };
}
